import React, { useContext } from 'react';
import './CardContainer.css';
import '../../common/componentMap';
import componentMap from '../../common/componentMap';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function CardContainer() {
  const environmentContext = useContext(EnvironmentContext);
  const { activeUser: user, selectedMonitoredIndividual, selectedUnit, userModules } = environmentContext;


  const userCanViewModule = (module) => {
    if (logComponent('CardContainer')) { console.debug('CardContainer userCanViewModule');  }

    if (user.groupTypeString !== 'Facility') return true;
    if (selectedMonitoredIndividual && module.showForSingleMonitoredIndividual) return true;
    if (selectedUnit && module.ShowForSingleUnit) return true;
    if (!selectedMonitoredIndividual && !selectedUnit && module.showForFacilityDashboard) return true;

    return false;
  }

  if (logComponent('CardContainer')) { console.debug('CardContainer rendered'); }

  return (
    userModules ?
      <div className="Card-Container">
          {
            userModules
              .filter(module => userCanViewModule(module))
              .map(module => {
                let props = {
                  key: module.name,
                  moduleDescription: module.description
                }

                return (
                  componentMap.has(module.name) ?
                    React.createElement(
                      componentMap.get(module.name),
                      props
                    ) :
                    null
                );
              })
          }
      </div> :
      null
  );
}